export const SoraLogin = (path) => `${process.env.REACT_APP_URL_SORA}${path}`;
export const BackEndAzureApi = (path) => `${process.env.REACT_APP_URL_TARS}${path}`;
export const BellApi = (path) => `${process.env.REACT_APP_URL_BELL}${path}`;
export const OlimpiaApi = (path) => `${process.env.REACT_APP_URL_OLIMPIA}${path}`;
export const GogolApi = (path) => `${process.env.REACT_APP_URL_GOGOL}${path}`;
export const AutenticApi = (path) => `${process.env.REACT_APP_URL_AUTENTIC}${path}`;